import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Link } from 'react-router-dom';
import { propArrayNum, propArrayShape, propBool, propFunc, } from '../../../../helpers/custom-prop-types';
import SearchFilterItems from './Common/SearchFilterItems';
const SearchFilterSeminarBody = (props) => {
    const { inputSeminarThemes, isShow, onChangeInputFilter, viewSeminarThemes } = props;
    return (_jsxs("div", Object.assign({ className: `search_list_filter_body ${isShow ? '' : 'is-dnone'}` }, { children: [_jsx("div", Object.assign({ className: 'search_list_filter_link_button_wrap' }, { children: _jsx(Link, Object.assign({ className: 'search_list_filter_link_button', to: '/seminar' }, { children: "\u3059\u3079\u3066\u306E\u30BB\u30DF\u30CA\u30FC\u3092\u898B\u308B" })) })), _jsx(SearchFilterItems, { inputItems: inputSeminarThemes, inputName: 'seminarTheme', onChangeInputFilter: onChangeInputFilter, viewItems: viewSeminarThemes })] })));
};
SearchFilterSeminarBody.propTypes = {
    inputSeminarThemes: propArrayNum().isRequired,
    isShow: propBool().isRequired,
    onChangeInputFilter: propFunc().isRequired,
    viewSeminarThemes: propArrayShape().isRequired,
};
export default SearchFilterSeminarBody;
